import React from 'react';
import { Switch } from '../../../../common';
import './style.scss';

export const SwitchBlock = ({ title, calback = () => {} }) => (
  <span className="switch_block">
    <Switch
      onChange={calback}
      label={title}
    />
  </span>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/SwitchBlock/index.js